import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'say-say-design-system',
    template: ``,
    styles: []
})
export class SayDesignSystemComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }
}
